<ng-container *ngIf="trackingText">
    <ng-container *ngIf="full">
        <div class="zas-row">
            <div class="zas-main-col">
                <zbd-input
                    #mainText
                    type="textarea"
                    [name]="name"
                    [label]="label"
                    class="gutter-main"
                    [rows]="1"
                    [focused-rows]="5"
                    [autogrow]="true"
                    [entity]="trackingText"
                    property="MainText"
                    [updateFn]="
                        trackingText.IsModified
                            ? persistence.updateTrackingText
                            : undefined
                    "
                    [validity]="validity"
                    [label-addon]="labelButtons"
                    [securityFilter]="'light'"
                >
                </zbd-input>
            </div>
        </div>
        <div *ngIf="showAdditional" class="zas-row">
            <div class="zas-main-col">
                <zbd-input
                    type="textarea"
                    name="additionalText"
                    label="Manuelle Ergänzung"
                    class="gutter-main"
                    [rows]="1"
                    [focused-rows]="5"
                    [autogrow]="true"
                    [entity]="trackingText"
                    property="AdditionalText"
                    [updateFn]="persistence.updateTrackingText"
                    [securityFilter]="'light'"
                ></zbd-input>
            </div>
        </div>
    </ng-container>
    <div *ngIf="!full" class="zas-row">
        <zbd-input
            type="text"
            [name]="name"
            [label]="label"
            class="zas-main-col"
            [entity]="trackingText"
            property="MainText"
            [updateFn]="
                trackingText.IsModified
                    ? persistence.updateTrackingText
                    : undefined
            "
            [validity]="validity"
            [securityFilter]="'light'"
        ></zbd-input>
        <div class="zas-main-col"></div>
    </div>
</ng-container>

<ng-template #labelButtons>
    <ng-content style="display: inline-block"></ng-content>
    <ng-container *ngIf="trackingText.IsModified">
        <ng-container *ngIf="snippets$ | async; let snippets; else: waiting">
            <zbd-snippets
                style="display: inline-block"
                *ngIf="snippets.length"
                [snippets]="snippets"
                (on-select)="onSnippetSelect($event)"
            ></zbd-snippets>
        </ng-container>
    </ng-container>
    <zbd-info style="display: inline-block" *ngIf="trackingText.IsModified">{{
        strings.TrackingInfoText
    }}</zbd-info>
    <zbd-request
        style="display: inline-block"
        *ngIf="!trackingText.IsModified"
        icon="icon-i-tracking-off"
        [message]="'Das Tracking wird hierdurch aufgehoben.'"
        (accepted)="setTracking(false)"
    ></zbd-request>
    <zbd-request
        style="display: inline-block"
        *ngIf="trackingText.IsModified"
        icon="icon-i-tracking-on"
        [message]="
            'Das Tracking wird hierdurch wiederhergestellt. Alle Änderungen in dieser Textbox gehen dadurch verloren.'
        "
        (accepted)="setTracking(true)"
    ></zbd-request>
</ng-template>

<ng-template #waiting>
    <span class="icon-loop spinning"></span>
</ng-template>
